import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button } from 'components/misc'
import styles from './form-button.styl'

export default class FormButton extends Component {
  static propTypes = {
    intlKey: PropTypes.string,
    pristine: PropTypes.bool,
    simple: PropTypes.bool,
    invalid: PropTypes.bool,
    // submitSucceeded: PropTypes.bool.isRequired,
    submitFailed: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.any
  }

  static defaultProps = {
    simple: false,
    disabled: false
  }

  render() {
    const {
      pristine,
      submitFailed,
      invalid,
      simple,
      intlKey,
      children,
      disabled
    } = this.props

    return (
      <span>
        {!pristine &&
        !simple && (
          <span>
            {!submitFailed && (
              <span className={styles.note}>
                <FormattedMessage
                  id="label.pending_changes"
                  defaultMessage="Pending changes ..."
                />
              </span>
            )}
            {invalid &&
            submitFailed && (
              <span className={`${styles.note} ${styles.hasError}`}>
                <FormattedMessage
                  id="errors.some_fields_requires_your_attention"
                  defaultMessage="Some fields require your attention"
                />
              </span>
            )}
          </span>
        )}
        <Button type="submit" {...this.props} disabled={pristine || disabled}>
          {intlKey ? (
            <FormattedMessage id={intlKey} defaultMessage={children} />
          ) : (
            children
          )}
        </Button>
      </span>
    )
  }
}
